import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectEnvEditFormComponent } from './project-env-edit-form.component';
import { ProjectEnvEditFormTranslationsModule } from './project-env-edit-form.translations';
import { UserDataFieldsModule } from '@zerops/zui/user-data-fields';
import { ZefFormModule } from '@zerops/zef/forms/modules';
import { ZefFormsModule } from '@zerops/zef/forms';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';

@NgModule({
  declarations: [ ProjectEnvEditFormComponent ],
  imports: [
    CommonModule,
    ProjectEnvEditFormTranslationsModule,
    UserDataFieldsModule,
    ZefFormModule,
    ZefFormsModule,
    MatSlideToggleModule
  ],
  exports: [ ProjectEnvEditFormComponent ]
})
export class ProjectEnvEditFormModule {

}
